import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MagicBackgroundStats } from "@/components/magic-background/magic-background-stats";
import { MagicBackgroundSDK } from "@/components/magic-background/magic-background-sdk";
import { FeatureChart } from "@/components/feature-chart";
import { GenerationsList } from "@/components/generations-list";

const MagicBackgroundPage: React.FC = () => {
  return (
    <>
      <main className="flex-1 space-y-6 p-2">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
            Magic Background
          </h2>
          <p className="text-muted-foreground">
            Monitor your background transformation performance and analytics
          </p>
        </div>

        <Tabs defaultValue="overview" className="space-y-6">
           <TabsList>
             <TabsTrigger value="overview">Overview</TabsTrigger>
             <TabsTrigger value="generations">Generations</TabsTrigger>
             <TabsTrigger value="playground">Playground</TabsTrigger>
           </TabsList>

          <TabsContent value="overview" className="space-y-6">
            {/* Feature Stats */}
            <MagicBackgroundStats />

            {/* Background Transformation Trends */}
            <Card>
              <CardHeader>
                <CardTitle>Background Transformation Trends</CardTitle>
                <CardDescription>Images processed over time</CardDescription>
              </CardHeader>
              <CardContent>
                <FeatureChart
                  featureKey="magicBackground"
                  usersKey="magicBackgroundUsers"
                  dataLabel="Images Processed"
                  color="#8B5CF6"
                  showUsers={true}
                />
              </CardContent>
            </Card>


          </TabsContent>

          <TabsContent value="generations" className="space-y-6">
            <GenerationsList type="magic-background" />
          </TabsContent>

          <TabsContent value="playground" className="space-y-6">
             <div className="w-full mx-auto">
              <MagicBackgroundSDK />
            </div>
          </TabsContent>
        </Tabs>
      </main>
    </>
  );
};

export default MagicBackgroundPage;